const initialState = {
  slideshows: {},
};

export default function reducer(state = initialState, action = {}) {
  const slideshows = state.slideshows;

  switch (action.type) {
    case 'SLIDESHOW_LOADING':
      if (!slideshows[action.id]) {
        slideshows[action.id] = {};
      }

      slideshows[action.id].loading = action.loading;

      return Object.assign({}, state, {
        slideshows,
      });

    case 'SLIDESHOW_ACTIVE_SLIDE_CHANGED':
      if (!slideshows[action.id]) {
        slideshows[action.id] = {};
      }

      slideshows[action.id].activeSlide = action.activeSlide;

      return Object.assign({}, state, {
        slideshows,
      });

    case 'SLIDESHOW_TRANSITIONING':
      if (!slideshows[action.id]) {
        slideshows[action.id] = {};
      }

      slideshows[action.id].transitioning = action.transitioning;

      return Object.assign({}, state, {
        slideshows,
      });

    case 'SLIDESHOW_FIRST_SLIDE_LOADED':
      if (!slideshows[action.id]) {
        slideshows[action.id] = {};
      }

      slideshows[action.id].firstSlideLoaded = action.firstSlideLoaded;

      return Object.assign({}, state, {
        slideshows,
      });

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./assets/js/src/reducers/slideshow.js
 **/